// Training Matrix (Phase 8, §21). Config for the generic People register.
import { GraduationCap } from "lucide-react";
import PeopleRegister from "@/components/people/PeopleRegister";

const FIELDS = [
    { key: "person_name", label: "Person", required: true, half: true },
    { key: "person_role", label: "Role", half: true },
    { key: "person_type", label: "Person type", type: "select", optionsKey: "person_types", half: true },
    { key: "topic", label: "Topic", type: "select", optionsKey: "topics", half: true },
    { key: "course_name", label: "Course name", required: true },
    { key: "provider", label: "Provider", half: true },
    { key: "status", label: "Status", type: "select", optionsKey: "statuses", half: true },
    { key: "date_completed", label: "Date completed", type: "date", half: true },
    { key: "expiry_date", label: "Expiry date", type: "date", half: true },
    { key: "reminder_date", label: "Reminder date", type: "date", half: true },
    { key: "notes", label: "Notes", type: "textarea" },
];

const COLUMNS = [
    {
        key: "person_name", label: "Person",
        search: (r) => `${r.person_name} ${r.person_role || ""} ${r.person_type}`,
        render: (r) => (
            <div>
                <div className="font-semibold text-[#1F1F1F]">{r.person_name}</div>
                <div className="text-[11px]" style={{ color: "#9A968F" }}>{r.person_role || r.person_type}</div>
            </div>
        ),
    },
    { key: "course_name", label: "Course", search: (r) => `${r.course_name} ${r.provider || ""}`, render: (r) => <div><div>{r.course_name}</div><div className="text-[11px]" style={{ color: "#9A968F" }}>{r.provider || ""}</div></div> },
    { key: "topic", label: "Topic" },
    { key: "person_type", label: "Type" },
    { key: "expiry_date", label: "Expiry", render: (r) => r.expiry_date || "—" },
];

export default function TrainingPage() {
    return (
        <PeopleRegister
            testid="training" title="Training Matrix" subtitle="staff, clients, contractors & duty holders"
            endpoint="/training" icon={GraduationCap} fields={FIELDS} columns={COLUMNS}
            fileLabel="Certificate" scoped showClientField
        />
    );
}
